import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiShield } = FiIcons;

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#fafafa] pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-6">
        <Link to="/" className="inline-flex items-center gap-2 text-emerald-700 font-bold mb-12 hover:gap-3 transition-all">
          <SafeIcon icon={FiArrowLeft} /> Back to Home
        </Link>
        
        <div className="glass-card rounded-[3rem] p-10 md:p-16 shadow-2xl border-white/40">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 bg-emerald-100 rounded-2xl flex items-center justify-center text-emerald-700">
              <SafeIcon icon={FiShield} className="text-2xl" />
            </div>
            <h1 className="text-4xl font-extrabold text-emerald-900">Privacy Policy</h1>
          </div>

          <div className="prose prose-emerald max-w-none space-y-8 text-gray-600 leading-relaxed">
            <p className="text-lg font-medium text-emerald-800">Last Updated: May 20, 2024</p>
            
            <p>
              Quant Asset Partners LLC ("we," "us," or "our") values your privacy. This Privacy Policy explains how we collect, use, and protect your information, specifically concerning SMS messaging through 10-Digit Long Code (10DLC) numbers.
            </p>

            <section>
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">1. Information We Collect</h2>
              <p>When you opt-in to receive SMS messages from us, we may collect your name, mobile phone number, and information regarding vacant land parcels you own.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">2. How We Use Your Information</h2>
              <p>We use this information strictly for real estate acquisition inquiries, providing cash offers for land, and responding to your questions. Message frequency varies based on your interaction with us but typically does not exceed 4 messages per month.</p>
            </section>

            <section className="bg-emerald-50 p-8 rounded-3xl border border-emerald-100">
              <h2 className="text-2xl font-bold text-emerald-900 mb-4 uppercase tracking-tight">3. NO SHARING OF PERSONAL INFORMATION</h2>
              <p className="font-medium">
                No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties. We may share your information with trusted service providers (such as our SMS platform) solely to facilitate our communications with you.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">4. Your Rights and Choices</h2>
              <p>You can opt-out of receiving SMS messages at any time by replying STOP to any message. For help, reply HELP.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">5. Contact Us</h2>
              <p>If you have questions about this policy, contact us at: <a href="mailto:acquisitions@quantassetpartners.com" className="text-emerald-700 font-bold underline">acquisitions@quantassetpartners.com</a>.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}